module.exports = __webpack_public_path__ + "img/43_22.d61488dd.png";